import React from "react";

export const ExtractContext = React.createContext({
    doSearch: null,
    parent: null,
});